var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_40323",
    "data-name": "Group 40323",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14929",
    "data-name": "Rectangle 14929",
    width: 16,
    height: 16,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user_3_",
    "data-name": "user (3)",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38776",
    "data-name": "Group 38776"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36728",
    "data-name": "Path 36728",
    d: "M11.95,9.05A6.973,6.973,0,0,0,9.29,7.382a4.047,4.047,0,1,0-4.579,0A7.011,7.011,0,0,0,0,14H1.094a5.906,5.906,0,1,1,11.812,0H14A6.954,6.954,0,0,0,11.95,9.05ZM7,7A2.953,2.953,0,1,1,9.953,4.047,2.956,2.956,0,0,1,7,7Z",
    transform: "translate(0)",
    fill: "#b2b9c4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserOutline);
export default __webpack_public_path__ + "static/media/user-outline.3396239665f712448b7ada6269e9c08e.svg";
export { ForwardRef as ReactComponent };